module.exports = __webpack_public_path__ + "static/media/argos.ab65cebb.png";